var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 10.909091,
    rx: 1,
    width: 15.272727,
    x: 0.727273,
    y: 0.727273
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79cff6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68bfe6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042c90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00247e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb1d43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d21034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d51931"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.54545455h3.63636364v2.54545455c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.54545455h3.63636364v2.54545455c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.727273.727273h15.272727v10.909091h-15.272727z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.727273.727273h6.545455v5.090909h-6.545455z",
    fill: "url(#d)",
    mask: "url(#g)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(10.181818 3.636364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.54545455h3.63636364v2.54545455c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.72727273 1.81818182c-.20083082 0-.36363637-.16280555-.36363637-.36363637 0-.20083081.16280555-.36363636.36363637-.36363636.20083081 0 .36363636.16280555.36363636.36363636 0 .20083082-.16280555.36363637-.36363636.36363637zm2.18181818 0c-.20083082 0-.36363636-.16280555-.36363636-.36363637 0-.20083081.16280554-.36363636.36363636-.36363636.20083081 0 .36363636.16280555.36363636.36363636 0 .20083082-.16280555.36363637-.36363636.36363637z",
    fill: "#2a915c",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.63636364v.72727273h-1.45454546v1.45454545h1.45454546v.72727273h-1.45454546v2.18181818h-.72727273v-2.18181818h-1.45454545v-.72727273h1.45454545v-1.45454545h-1.45454545z",
    fill: "url(#e)",
    mask: "url(#i)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.54545455 2.18181818-2.54545455-2.18181818h.36363636l2.54545455 1.81818182h.72727273l2.90909091-1.81818182v.18181818c0 .10041541-.0629217.22676225-.15160683.29010877l-2.39384772 1.70989123v.72727273l2.40859985 2.06451416c.07558276.06478522.0525152.11730402-.04496349.11730402-.10041541 0-.24473987-.04494407-.333425-.10829059l-2.39384772-1.70989123h-.72727273l-2.90909091 1.81818182v-.36363636l2.54545455-1.81818182z",
    fill: "url(#f)",
    transform: "translate(.727273 .727273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.09090909 2.99271544-2.85513771-2.44726089h.85513771l.10567967.03386664 2.49804125 1.78431517h.61686158l3.14305386-1.96440866v.50986321c0 .16126093-.09301266.34182269-.22774533.43806031l-2.31770921 1.65550658v.55008131l2.34510737 2.01009203c.20545829.1761071.10087691.43716886-.16328919.43716886-.14042625 0-.32130737-.0580163-.43910468-.14215723l-2.34643442-1.67602459h-.61686158l-3.14305386 1.96440866v-.78524827l2.54545454-1.81818182z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.72727273 2.54545455v1.45454545h2.54545454v1.82153529c0 .19897875.15566184.36028289.36704324.36028289h.72045898c.20271239 0 .36704324-.15691098.36704324-.36028289v-1.82153529h2.55237926c.1970064 0 .35671165-.15566184.35671165-.36704324v-.72045898c0-.20271238-.15640536-.36704323-.35671165-.36704323h-2.55237926v-1.81818182h-1.45454546v1.81818182z",
    fill: "url(#a)",
    fillRule: "nonzero",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.72727273 2.90909091h2.90909091v-.36363636-1.81818182h.72727272v1.81818182.36363636h2.90909091v.72727273h-2.90909091v.36363636 1.81818182h-.72727272v-1.81818182-.36363636h-2.90909091z",
    fill: "url(#f)",
    fillRule: "nonzero",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj);
export default __webpack_public_path__ + "static/media/FJ.8e101aec35964294a5d4f4ea2a1be9e7.svg";
export { ForwardRef as ReactComponent };